import { getOrderVariantTitle } from "@utils/getOrderVariantTitle";
import { LineVariantProps } from "./LineItem.model";
import * as Styled from "./LineItem.styled";

const VariantDisplay = ({ title, variant, isBundle, className }: LineVariantProps) => {
  if (!variant) return;

  const variantOptions = [];
  const { variantOption1, variantOption2 } = variant;
  const variantTitle = getOrderVariantTitle(title, variant, isBundle);

  if (isBundle && variantOption1?.value) {
    variantOptions.push({
      title: variantOption1.value,
      quantity: 1,
    });
  }

  if (isBundle && variantOption2?.value) {
    variantOptions.push({
      title: variantOption2.value,
      quantity: 1,
    });
  }

  if (!isBundle && variantTitle) {
    variantOptions.push({ title: variantTitle });
  }

  if (variantOptions.length < 1) return;

  return (
    <Styled.VariantDisplay className={className}>
      {variantOptions.map((option, idx) => (
        <Styled.VariantText key={idx}>
          {option.title}
          {option.quantity ? ` (${option.quantity})` : ""}
        </Styled.VariantText>
      ))}
    </Styled.VariantDisplay>
  );
};

export default VariantDisplay;
